/// <reference path="../Page/PageManager.js" />
function createModalDiv(
  url,
  args,
  width,
  height,
  openerInstance,
  callBack,
  activeElement,
  vid,
  source
) {
  var modals = $(".modal");
  // if this is a child modal dialog (because we have a modal div already open) we need
  // to use the vid of the parent.  All modal divs will be associated with the parent view id
  if (openerInstance.isModalDiv) {
    var currentVisibleDialogs = $(".modal:visible");
    if (currentVisibleDialogs.length > 0) {
      vid = currentVisibleDialogs[0].getAttribute("vid");
    }
  }
  var id = "modal_" + modals.length;
  var divContent = $(
    "<div class='modal ipsModalDiv' id='" + id + "' vid='" + vid + "' ></div>"
  );
  divContent.appendTo("body");
  var adjustedHeight =
    parseInt(height, 10) - themeDefinition.height.modalDiv.padding;
  var adjustedWidth =
    parseInt(width, 10) + themeDefinition.width.modalDiv.padding;
  
  // if the source is a focusable element, set it as the activeElement
  let sourceElement = GetView(vid).document.getElementById(source)

  if ($(activeElement).is('body') && sourceElement && sourceElement.focus) {
    activeElement = sourceElement
  }

  divContent.ipsModalDiv({
    url: url,
    args: args,
    width: adjustedWidth,
    height: adjustedHeight,
    openerInstance: openerInstance,
    callBack: callBack,
    count: modals.length,
    id: "modal_" + modals.length,
    activeElement: activeElement,
    vid: vid,
    source: source
  });
}
// makes the modal div associated with the current targetViewId visible while hiding the rest
function showModalDivs(targetViewId) {
  var modals = $(".modal");
  if (modals.length > 0) {
    var overlays = $(".modalDialogOverlay");
    hideModalDivs(modals, overlays);
    var visibleWindows = modals.filter(".modal[vid=" + targetViewId + "]");
    if (visibleWindows.length > 0) {
      visibleWindows.show();
      $(document.body).addClass("modal-engaged");
      var visibleOverlays = overlays.filter(
        ".modalDialogOverlay[vid=" + targetViewId + "]"
      );
      visibleOverlays.show();
    }
  }
}
// hides all of the modal divs
function hideModalDivs(modals, overlays) {
  modals = modals ? modals : $(".modal");
  if (modals.length > 0) {
    overlays = overlays ? overlays : $(".modalDialogOverlay");
    modals.hide();
    overlays.hide();
  }
}
$(function($) {
  $.widget("ui.ipsModalDiv", {
    _create: function() {
      this.previousPos = $(this.options.activeElement).scrollTop();
      var fullScreen = false;
      var self = this;
      // make sure that stacking modal windows have increasing z-indexes
      this.element.css("z-index", 3000 + this.options.count);
      // ensure we have a min popup
      if (
        !this.options.height ||
        this.options.height < themeDefinition.height.modalDiv.min
      ) {
        this.options.height = themeDefinition.height.modalDiv.min;
      }
      if (
        !this.options.width ||
        this.options.width < themeDefinition.width.modalDiv.min
      ) {
        this.options.width = themeDefinition.height.modalDiv.min;
      }
      // cap the maximum size based on the theme setting in relation to the current browser size
      var browserDim = GetDocumentDim();
      var fullScreenDim = {};
      fullScreenDim.height =
        browserDim.height * themeDefinition.height.modalDiv.maxPercentage;
      fullScreenDim.width =
        browserDim.width * themeDefinition.width.modalDiv.maxPercentage;
      // if we pass the given threshold then make the modal div full-screen
      var thresholdWidth =
        browserDim.width * themeDefinition.width.modalDiv.fullscreenThreshold;
      var thresholdHeight =
        browserDim.height * themeDefinition.height.modalDiv.fullscreenThreshold;
      if (
        this.options.width >= thresholdWidth ||
        this.options.height >= thresholdHeight
      ) {
        this.options.height = fullScreenDim.height;
        this.options.width = fullScreenDim.width;
        fullScreen = true;
      } else {
        var resize = function() {
          self.element.off("resize.ipsModalDiv");
          self.element.addClass("resizable");
        };
        this.element.on("resize.ipsModalDiv", resize);
      }
      var title = "Infor Public Sector";
      if (this.options.args && this.options.args.length > 0) {
        title = this.options.args[0];
      }
      var html = [];
      var frameId = "__modalFrame__" + this.options.count;
      html.push('<div class="modal-content">');
      html.push(
        '<div class="modal-header"><h1 id="modal-title" class="modal-title" tabindex="0">' +
          title +
          "</h1></div>"
      );
      html.push('<div class="modal-body" >');
      html.push(
        '<iframe scrolling="no" tabindex="0" frameborder="0" isModalDiv="true" width="100%" height="' +
          self.options.height +
          '" id="' +
          frameId +
          '"></iframe></div>'
      );
      html.push("</div>");
      this.element.append(html.join(""));
      var frame = this.element.find("iframe");
      this.element.css({ width: self.options.width + "px" });
      frame[0].opener = this.options.openerInstance;
      frame[0].dialogArguments = this.options.args;
      var dialog = this.element
        .modal({
          trigger: "immediate",
          resizable: !fullScreen
        })
        .on("close", function() {
          var ret = {};
          var val = self.element.data("returnValue");
          if (val) {
            ret = val;
          }
          self.options.callBack(
            ret,
            self.options.source,
            self.options.openerInstance,
            self.options.vid
          );
          setTimeout(function() {
            frame[0].opener = null;
            frame[0].dialogArguments = null;
            frame[0].modalDivContext = null;
            $("#" + frameId).attr("src", "");
            $(
              "#" + self.element[0].id + "buttonset_footer_focus_redirect"
            ).off();
            $(
              "#" + self.element[0].id + "buttonset_footer_focus_redirect"
            ).remove();
            self.element.removeData();
            self.element.off();
            self.element.remove();
            if (
              self.options.activeElement &&
              self.options.activeElement.focus
            ) {
              self.options.activeElement.focus();
              $(self.options.activeElement).scrollTop(self.previousPos);
              var inputElementList = self.options.activeElement.parentElement.getElementsByTagName(
                "input"
              );
              for (var i = 0; i < inputElementList.length; i++) {
                if (inputElementList[i].id == self.options.source + "_input") {
                  setTimeout(function() {
                    inputElementList[i].focus();
                  }, 1);
                  break;
                }
                if (inputElementList[i].id == self.options.source.replace("!","_") + "_input") {
                  setTimeout(function() {
                    inputElementList[i].focus();
                  }, 1);
                  break;
                }
              }
            }
            self.options.activeElement = null;
            var modals = $(".modal");
            if (modals.length > 0) {
              $(document.body).addClass("modal-engaged");
            }
          }, 0);
        });
      if (title == "Print Report") {
        $('.inforCloseButton').css("display", "block");
      }
      if (dialog.data("modal")) {
        var overlay = dialog.data("modal").overlay;
        overlay.addClass("modalDialogOverlay");
        overlay.attr("vid", this.options.vid);
      }
      frame.attr("src", this.options.url);
      var context = {
        control: dialog,
        frame: frame,
        opener: this.options.openerInstance,
        openInMain: createModalDiv,
        winInstance: window
      };
      context.removeDiv = function(ret) {
        self.element.data("returnValue", ret);
        self.element.inforDialog("close");
        if (self.options.activeElement && self.options.activeElement.focus) {
          self.options.activeElement.focus();
        }
      };
      context.addButtons = function(buttons, clickDelegate) {
        var html = [];
        html.push('<div class="modal-buttonset">');
        for (var i = 0; i < buttons.length; i++) {
          var button = buttons[i];
          var tag = new TagBuilder("button");
          tag
            .addAttribute("type", "button")
            .addAttribute("buttonId", button.buttonId)
            .addAttribute(
              "class",
              i == 0 ? "inforFormButton default" : "inforFormButton"
            )
            .addAttribute(
              "title",
              button.title == button.text ? "" : button.title
            )
            .addAttribute("id", self.options.id + "_" + button.buttonId);
          if (button.enabled === false) {
            tag.addAttribute("disabled", "disabled");
          }
          tag.setContent(button.text);
          html.push(tag.toString());
        }
        html.push("</div>");
        var redirectId = self.element[0].id + "buttonset_footer_focus_redirect";
        //Create a Div that when focus is received it is set back to the title div of the modal div. When you tab this will keep the focus only on items
        //within the modal div dialog box
        var footerFocusRedirect =
          '<div id="' + redirectId + '" tabindex="0"> </div>';
        html.push(footerFocusRedirect);
        self.element.find(".modal-buttonset").remove();
        self.element.find("#" + redirectId).remove();
        self.element.find(".modal-body").append(html.join(""));
        self.element.find("button").click(clickDelegate);
        //When we tab to this div, redirect focus back to the top of the modal div dialog box so subsequent tabs will retain focus on items on the
        //modal div dialog box.
        var buttonset_footer_focus_redirect = self.element.find(
          "#" + redirectId
        );
        buttonset_footer_focus_redirect.attr("modalId", self.element[0].id);
        buttonset_footer_focus_redirect.on("focus", function(event) {
          var modalId = $(this).attr("modalId");
          if (modalId.length > 0) {
            $("#" + modalId)
              .find("#modal-title")
              .focus();
          }
        });
      };
      context.setTitle = function(title) {};
      frame[0].modalDivContext = context;
    },
    openContextMenu: function(id, commands, vid, originalView) {
      var buttonId = this.options.id + "_" + id;
      var buttonEle = this.element.find("#" + buttonId);
      var view = GetView(vid);
      view.openPopupMenu({
        items: commands,
        parentControl: buttonEle,
        vid: vid,
        view: originalView,
        $jquery: $,
        isModalDiv: true
      });
    }
  });
});
var processModalDivClose = function(ret, source, opener, vid) {
  var view = GetView(vid);
  if (ret.app || (ret.monk && ret.mthd)) {
    view.addEvent(
      ret.app,
      ret.monk,
      ret.mthd,
      source,
      ret.args,
      undefined,
      vid
    );
    view.eventAdded(vid);
  } else if (ret.cust) sendCustomRequest(ret.cust, vid);
  else if (ret.logout) {
    //01/03/06 cpb this comes from inactivity message prompt indicate that logout is happening
    //user has timed out
    if (opener == undefined && instance.document.location.search.length > 0) {
      // modal child window
      var logReturn = new Object();
      logReturn.logout = true;
      instance.returnValue = logReturn;
      closeWindow(vid, false, logReturn);
    } else {
      sendPingRequest(false, vid);
    }
  }
};
